import { configureStore } from '@reduxjs/toolkit';
import { counterReducer } from '../components/Counter/slice';
import secureReducer, { loadSecureStateFromStorage, saveSecureStateToStorage, ISecureSlice } from '../components/SecureRoute/slice'
import dashboardReducer from '../pages/Dashboard/slice'
import menuReducer from '../pages/Menu/slice'
import menuRequestsReducer from '../pages/MenuLoadRequest/slice'
import restaurantReducer from '../pages/Restaurant/slice'
import locationReducer from '../pages/Location/slice'
import reviewReducer from '../pages/Reviews/slice'
import eaterReducer from '../pages/Eater/slice'
import adminReducer from '../pages/Admin/slice'
import unblockUserReducer from "../pages/UnblockUsers/slice";
import restaurantApprovalReducer from '../pages/RestaurantApproval/slice';
import dishImageSuggestionsReducer from '../pages/Menu/dishImageSuggestionsSlice';
import missingMenuQueueReducer from '../pages/MissingMenuQueue/slice';
import foodAreasReducer from '../pages/FoodAreas/slice';
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  counter: counterReducer,
  secure: secureReducer,
  dashboard: dashboardReducer,
  menuRequests: menuRequestsReducer,
  menu: menuReducer,
  restaurant: restaurantReducer,
  location: locationReducer,
  reviews: reviewReducer,
  eater: eaterReducer,
  admin: adminReducer,
  unblockuser: unblockUserReducer,
  restaurantApproval: restaurantApprovalReducer,
  dishImageSuggestions: dishImageSuggestionsReducer,
  missingMenuQueue: missingMenuQueueReducer,
  foodAreas: foodAreasReducer
})


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const configureAppStore = (initialState = {}) => {
  // Load persisted secure state from localStorage
  // Use try-catch to handle cases where loadSecureStateFromStorage might not be available (e.g., in tests)
  let persistedSecureState: ISecureSlice | undefined;
  try {
    persistedSecureState = loadSecureStateFromStorage();
  } catch (error) {
    // In test environments, this might fail due to circular dependencies
    // Fall back to undefined
    persistedSecureState = undefined;
  }
  
  // Merge persisted secure state into initial state
  const preloadedState = {
    ...initialState,
    secure: persistedSecureState ?? (initialState as any).secure
  };

  const store = configureStore({
                  reducer: rootReducer, 
                  preloadedState,
                  devTools: process.env.NODE_ENV !== 'production'
                }
              )

  // Subscribe to store changes to persist secure state
  store.subscribe(() => {
    const state = store.getState();
    const secureState: ISecureSlice = state.secure;
    saveSecureStateToStorage(secureState);
  });

  return store;
};

export const store = configureAppStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof configureAppStore>;
